import { useMoney, MoneyConfig } from './useMoney'

interface MoneyProp extends MoneyConfig {
  amount: string
}

export const Money = ({ amount, ...moneyConfig }: MoneyProp): string | JSX.Element => {
  const { formatMoney } = useMoney(moneyConfig)
  return formatMoney(amount)
}
